import React from "react";

// Styles
import "./assets/css/index.scss";

// components
import Layout from "./components/Layout";

// Routes
import Routes from "./routes";

const App: React.FC = () => <Layout children={Routes} />;

export default App;
